(() => {
  const scripts = new Map();

  class DeferredContent extends HTMLElement {
    connectedCallback() {
      if (this.loaded || !this.querySelector(':scope > template')) return;
      if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
        this.load();
        return;
      }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.load();
      }, { rootMargin: '600px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      const template = this.querySelector(':scope > template');
      if (this.loaded || !template) return;
      this.loaded = true;
      this.observer?.disconnect();

      const content = document.importNode(template.content, true);
      const bootstrap = this.hasAttribute('data-trustpilot')
        ? content.querySelector('script[src*="widget.trustpilot.com/bootstrap/"]')
        : null;
      const bootstrapUrl = bootstrap?.src;
      bootstrap?.remove();
      this.replaceChildren(content);

      if (!this.hasAttribute('data-trustpilot')) return;
      try {
        if (!window.Trustpilot && bootstrapUrl) {
          if (!scripts.has(bootstrapUrl)) {
            scripts.set(bootstrapUrl, new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = bootstrapUrl;
              script.async = true;
              script.onload = resolve;
              script.onerror = reject;
              document.head.append(script);
            }));
          }
          await scripts.get(bootstrapUrl);
        }
        this.querySelectorAll('.trustpilot-widget').forEach(widget => {
          if (!widget.querySelector('iframe')) window.Trustpilot?.loadFromElement(widget);
        });
      } catch {
        scripts.delete(bootstrapUrl);
      }
    }
  }

  if (!customElements.get('ms-deferred-content')) {
    customElements.define('ms-deferred-content', DeferredContent);
  }
})();
